// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e527af9e","453":"9537af23","667":"d6d0f879","977":"ee819552"}[chunkId] + ".chunk.js";
};